export default __webpack_public_path__ + "static/media/ed.729688c6.png";